window.ClientHelper = {
    url: null,
    infoWindows: [],
    zones: [],
    markers: {},
    initializeZones: function(allZones){
        let self = this;
        self.zones = allZones;
        $('#search_city').change(function() {
            let selectedCityId= $(this).val();
            self.toggleZones(selectedCityId);
        });
    },
    toggleZones: function(cityId){
        let self = this;
        let selectedZones = self.zones.filter(item => item.city_id === Number(cityId));
        const $select = $('#search_zone');
        $select.empty();
        $select.append('<option value="">Seleccione una opción</option>');
        selectedZones.forEach(item => {
            $select.append(`<option value="${item.id}">${item.name}</option>`);
        });
    },
    loadZones: function(zoneId, map){
        let self = this;

        $("#marker-search").off("change");
        
        $("#marker-search").on("change", function () {
            const markerId = $(this).val();
            const marker = self.markers[markerId];

            if (marker) {
                map.setCenter(marker.getPosition());
                map.setZoom(21);

                $.get(`/tracking/clients/${markerId}/popup`, function (data) {
                    self.createInfoWindow(map, marker, data);
                });
            }
        });

        $.post(self.url,
            {zone_id: zoneId},
            function(data) {
                self.clearMarkers();
                
                const fileExtension = data.use_png ? '.png' : '.svg';
                
                data.clients.forEach(function(coord) {
                    const marker = new google.maps.Marker({
                        position: { lat: parseFloat(coord.lat), lng: parseFloat(coord.long) },
                        map: map,
                        title: coord.name,
                        icon: {
                            url: "/pines/" + data.zone_color + fileExtension,
                            scaledSize: new google.maps.Size(32, 51),
                            anchor: new google.maps.Point(20, 51)
                        }
                    });

                    $("#marker-search").append(
                        `<option value="${coord.id}">${coord.name}</option>`
                    );

                    marker.addListener("click", () => {
                        $.get(coord.popup_url, function (data) {
                            self.createInfoWindow(map, marker, data);
                        });
                    });

                    self.markers[coord.id] = marker;
                });

                const bounds = new google.maps.LatLngBounds();
                Object.keys(self.markers).forEach(function(key) {
                    if (self.markers[key]) {
                        bounds.extend(self.markers[key].getPosition());
                    }
                });
                map.fitBounds(bounds);
            }
        );
    },
    clearMarkers: function () {
        let self = this;
        
        $("#marker-search").empty();
        $("#marker-search").append(
            `<option value="" disabled selected>Buscar un lugar...</option>`
        );
        
        Object.keys(self.markers).forEach(function(key) {
            if (self.markers[key]) {
                self.markers[key].setMap(null);
            }
        });
        self.markers = {};
    },
    createInfoWindow: function(map, marker, content) {
        let self = this;
        const infoWindow = new google.maps.InfoWindow({
            content: content,
        });
        self.closeAllInfoWindows();
        infoWindow.open(map, marker);

        self.infoWindows.push(infoWindow);
    },
    closeAllInfoWindows: function() {
        let self = this;
        self.infoWindows.forEach((infoWindow) => infoWindow.close());
    }
}